import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { FieldRating } from '@/components/form/field-rating';

import type { EstateValidationSchemaType } from '../../schemas/estate-validation';

export const RatingsForm = () => {
  const { t } = useTranslation();

  const methods = useFormContext<EstateValidationSchemaType>();

  return (
    <div className="space-y-2">
      <h4 className="text-md font-bold">{t('qualityAndCondition')}</h4>
      <div className="grid grid-cols-[80px_1fr_1fr] gap-y-1">
        <div />
        <p className="text-base text-primary">{t('quality')}</p>
        <p className="text-base text-primary">{t('condition')}</p>
        <p className="text-sm text-text-secondary">{t('kitchen')}*:</p>
        <FieldRating methods={methods} name="estateRatings.kitchenQuality" />
        <FieldRating methods={methods} name="estateRatings.kitchenCondition" />
        <p className="text-sm text-text-secondary">{t('bathroom')}*:</p>
        <FieldRating methods={methods} name="estateRatings.bathroomCondition" />
        <FieldRating methods={methods} name="estateRatings.bathroomQuality" />
        <p className="text-sm text-text-secondary">{t('flooring')}*:</p>
        <FieldRating methods={methods} name="estateRatings.flooringQuality" />
        <FieldRating methods={methods} name="estateRatings.flooringCondition" />
        <p className="text-sm text-text-secondary">{t('windows')}*:</p>
        <FieldRating methods={methods} name="estateRatings.windowsQuality" />
        <FieldRating methods={methods} name="estateRatings.windowsCondition" />
      </div>
    </div>
  );
};
